/* Native complete selections. Browsers without JS retain product links/forms. */
(()=>{
  const initialize=root=>{
    if(root.dataset.wnfrReady)return;root.dataset.wnfrReady='true';
    const dialog=root.querySelector('[data-wnfr-dialog]');let opener=null;
    const roomStates=new Map();
    const syncRoom=key=>{
      const state=roomStates.get(key);if(!state)return;
      root.querySelectorAll('[data-wnfr-cart]').forEach(form=>{
        if(form.dataset.roomKey!==key)return;
        const button=form.querySelector('button[type=submit]'),status=form.querySelector('[role=status]');
        button.disabled=true;button.textContent=state.type==='success'?'Selection added to cart':state.type==='pending'?'Adding selection…':'Review your cart';
        status.replaceChildren(document.createTextNode(state.message));
        if(state.type!=='pending'){const link=document.createElement('a');link.href=form.dataset.cartUrl||'/cart';link.textContent='Review your cart and delivery options';status.append(document.createTextNode(' '),link);}
      });
    };
    const close=()=>{dialog?.close();opener?.focus();};
    root.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-wnfr-open]');
      if(trigger&&dialog?.showModal&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey){
        const source=document.getElementById(trigger.dataset.wnfrOpen);if(!source)return;
        event.preventDefault();event.stopImmediatePropagation();opener=trigger;
        const clone=source.cloneNode(true);clone.id='wnfr-dialog-selection';
        clone.querySelectorAll('[id]').forEach(e=>e.id='dialog-'+e.id);
        dialog.querySelector('[data-wnfr-dialog-content]').replaceChildren(clone);
        clone.querySelectorAll('[data-wnfr-cart]').forEach(form=>syncRoom(form.dataset.roomKey));
        dialog.querySelector('h2').textContent=source.dataset.wnfrTitle||'Shop this room';
        dialog.showModal();trigger.setAttribute('aria-expanded','true');
        const focusIndex=trigger.dataset.wnfrFocus;
        if(focusIndex!==undefined){const item=clone.querySelectorAll('.wnfr-room-item')[Number(focusIndex)];item?.scrollIntoView({block:'nearest'});(item?.querySelector('a')||item)?.focus();}
      }
      if(event.target.closest('[data-wnfr-close]'))close();
    },{capture:true});
    dialog?.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
    dialog?.addEventListener('close',()=>{opener?.setAttribute('aria-expanded','false');opener?.focus();});
    root.addEventListener('submit',async event=>{
      const form=event.target.closest('[data-wnfr-cart]');if(!form)return;
      event.preventDefault();event.stopPropagation();
      const button=form.querySelector('button[type=submit]'),status=form.querySelector('[role=status]');
      const roomKey=form.dataset.roomKey;
      if(button.disabled||roomStates.has(roomKey))return;
      roomStates.set(roomKey,{type:'pending',message:'Checking this complete selection…'});syncRoom(roomKey);
      const fd=new FormData(form),items=[];
      for(let i=0;fd.has(`items[${i}][id]`);i++)items.push({id:Number(fd.get(`items[${i}][id]`)),quantity:Number(fd.get(`items[${i}][quantity]`))});
      let requestStarted=false;
      try{
        if(!items.length||items.some(i=>!Number.isSafeInteger(i.id)||!Number.isInteger(i.quantity)||i.quantity<1))throw new Error('Review the product options before adding this selection.');
        const route=(window.Shopify?.routes?.root||'/')+'cart/add.js';
        requestStarted=true;
        const response=await fetch(route,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'This selection is no longer available. Review the product options.');
        roomStates.set(roomKey,{type:'success',message:'The selected available furniture has been added.'});syncRoom(roomKey);
        document.dispatchEvent(new CustomEvent('cart:build'));
      }catch(error){roomStates.set(roomKey,{type:'review',message:(error.message||'The request could not be confirmed.')+(requestStarted?' Some items may have been added. Review your cart before trying again.':'')});syncRoom(roomKey);if(requestStarted)document.dispatchEvent(new CustomEvent('cart:build'));}
    },{capture:true});
  };
  const scan=()=>document.querySelectorAll('[data-wnfe]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
